import React, {ReactNode} from 'react';
import classNames from 'classnames';

import {BackIcon} from '../icons/BackIcon';
import {Button} from '../Button';
import {PersonAdd} from '../icons/PersonAdd';

import './HeaderMenu.css';

export interface HeaderMenuProps {
    title: string;
    isMobile: boolean;
    hasBack: boolean;
    onBack?: () => void;
    inviteLabel: string;
    onInvite: () => void;
    /** Slot: upgrade plan button (rendered only when on free plan) */
    upgradeButton?: ReactNode;
    /** Slot: notification bell button */
    notificationButton?: ReactNode;
    /** Slot: profile/avatar icon */
    profileIcon?: ReactNode;
    className?: string;
}

export const HeaderMenu = ({
    title,
    isMobile,
    hasBack,
    onBack,
    inviteLabel,
    onInvite,
    upgradeButton,
    notificationButton,
    profileIcon,
    className,
}: HeaderMenuProps) => {
    return (
        <header
            className={classNames('hm', {'theme-dark': isMobile}, className)}
        >
            <div className="hm_sb title-medium-bold">
                {hasBack && onBack ? (
                    <BackIcon
                        additionalPadding={isMobile ? 12 : undefined}
                        className="Quizzes__BackIcon"
                        onClick={onBack}
                    />
                ) : null}
                <span className="title-large-bold hm-title">{title}</span>
            </div>
            <div className="hm_button">
                <Button
                    type="neutral"
                    style="soft"
                    Icon={PersonAdd}
                    size="md"
                    text={!isMobile ? inviteLabel : null}
                    onClick={onInvite}
                />
            </div>
            {upgradeButton ?? null}
            {notificationButton ?? null}
            {profileIcon ?? null}
        </header>
    );
};
